const anexosStore = {
    namespaced: true,
    state: {
        docs: []
    },
    mutations: {
        addDoc(state, data) { state.docs.push(data) },
        setDocs(state, docs) { state.docs = docs }
    },
    actions: {
    },
    getters: {
    },
}

export default anexosStore
